import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { SiteContext } from '../../utils/common';
import Button from '../Button/Button';
import useStyles from './NewsLetter.styles';
import clsx from 'clsx';
import Modal from '../Modal/Modal';
import NewsletterSignUp from '../NewsletterSignUp/NewsletterSignUp';
import RichText from '../RichText/RichText';
import { newsLetterBackgroundClass } from '../../styles/jss/utils';
import SplitContentBySlash from '../../utils/SplitContentBySlash';
const NewsLetter = (props) => {
    const { title, body, backgroundColor, titleTextVariant, textAlignment } = props;
    const { bgClass } = newsLetterBackgroundClass(backgroundColor);
    const { newsletterSignUp, signUp } = props;
    const { isFlyingFlowers } = useContext(SiteContext);
    const { classes } = useStyles();
    const [isOpen, setOpen] = useState(false);
    // Compute alignment class based on textAlignment and isFlyingFlowers
    const getAlignClass = () => {
        if (isFlyingFlowers)
            return classes.alignCenter;
        if (textAlignment === 'CENTER')
            return classes.alignCenter;
        return classes.defaultAlign;
    };
    // Compute title class
    const getTitleClass = () => clsx(classes.title, getAlignClass(), titleTextVariant === 'LARGE_ADVERTISING' && !isFlyingFlowers
        ? classes.largeSizedTitle
        : classes.standardSizedTitle);
    // Compute body text class
    const getBodyTextClass = () => clsx(classes.bodyText, getAlignClass());
    // Compute button class
    const getButtonClass = () => clsx(classes.button, getAlignClass());
    // Render heading with SplitContentBySlash if not FlyingFlowers
    const resolveTitle = (title, isFlyingFlowers, titleLineClass) => {
        return !isFlyingFlowers ? (_jsx(SplitContentBySlash, { content: title, classNames: { headingLine: titleLineClass } })) : (title);
    };
    const headingTitle = resolveTitle(title, isFlyingFlowers, clsx(classes.titleParts, (isFlyingFlowers || textAlignment === 'CENTER') && classes.titlePartsCenter));
    return (_jsxs(_Fragment, { children: [_jsx(Modal, { open: isOpen, setOpen: setOpen, onClose: () => setOpen(false), title: newsletterSignUp === null || newsletterSignUp === void 0 ? void 0 : newsletterSignUp.title, maxWidth: "md", children: _jsx(NewsletterSignUp, { newsletterSignUp: newsletterSignUp, signUp: signUp, setOpen: setOpen }) }), _jsxs("div", { className: clsx(classes.container, bgClass), children: [title && _jsx("h2", { className: getTitleClass(), children: headingTitle }), _jsx(RichText, { content: body, className: getBodyTextClass() }), _jsx(Button, { variant: isFlyingFlowers ? 'secondary' : 'primary', title: 'Sign me up', onClick: () => setOpen(true), className: getButtonClass(), thin: true })] })] }));
};
export default NewsLetter;
